import { create } from 'zustand'
import type { AppState, Screen, QuizAnswer, DnaKey, DnaProfile, Destination } from '@/types'

const LS_EMAIL_KEY = 'sanctum_lead_email'

function readStoredEmail(): string {
  try { return localStorage.getItem(LS_EMAIL_KEY) || '' } catch { return '' }
}

export const useAppStore = create<AppState>((set) => ({
  screen: 'welcome', answers: [], dnaKey: '🌿',
  dnaProfile: null, selectedDestination: null, aiSummary: '', isLoading: false,
  email: readStoredEmail(), hasUnlocked: !!readStoredEmail(),
  setScreen: (screen: Screen) => set({ screen }),
  addAnswer: (answer: QuizAnswer) => set((state) => ({
    answers: [...state.answers.filter((a) => a.questionIndex !== answer.questionIndex), answer],
    dnaKey: answer.questionIndex === 0 ? (answer.emoji as DnaKey) : state.dnaKey,
  })),
  setDnaKey: (key: DnaKey) => set({ dnaKey: key }),
  setDnaProfile: (profile: DnaProfile) => set({ dnaProfile: profile }),
  setSelectedDestination: (dest: Destination) => set({ selectedDestination: dest }),
  setAiSummary: (summary: string) => set({ aiSummary: summary }),
  setIsLoading: (loading: boolean) => set({ isLoading: loading }),
  setEmail: (email: string) => {
    try { localStorage.setItem(LS_EMAIL_KEY, email) } catch { /* ignore */ }
    set({ email })
  },
  setHasUnlocked: (hasUnlocked: boolean) => set({ hasUnlocked }),
  resetJourney: () => set({ screen: 'welcome', answers: [], dnaKey: '🌿', dnaProfile: null, selectedDestination: null, aiSummary: '', isLoading: false }),
}))
